<grid-content class="interactions-part" [setup]="setup" [namedSize]="'CustomHeight'" [customHeight]="customHeight()" [rows]="engagements()"></grid-content>